export type MeetStartQueryParams = {
    /** Livekit JWT — только bootstrap из messenger, не invite link. */
    token: string | null;
    wssUrl: string | null;
    /** Messenger bootstrap: имя пользователя мессенджера. */
    fullName: string | null;
    language: string | null;
    isP2P: boolean;
    isSIP: boolean;
    soundEnabledParam: string | null;
    notificationsEnabledParam: string | null;
    /** Snapshot политики на момент открытия из messenger — не для шаринг invite link. */
    joinApprovalPolicy: string | null;
    initiatorId: string | null;
    callId: string | null;
    workspaceId: string | null;
};

export const usePrepareMeet = () => {
    const getStartQueryParams = (): MeetStartQueryParams => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const wssUrl = params.get('wss');
        const fullName = params.get('fullName');
        const language = params.get('language');
        const types = params.get('types')?.split(',') ?? '';
        const isP2P = types.includes('P2P');
        const isSIP = types.includes('SIP');
        const soundEnabledParam = params.get('soundEnabled');
        const notificationsEnabledParam = params.get('notificationsEnabled');
        const joinApprovalPolicy = params.get('joinApprovalPolicy');
        const initiatorId = params.get('initiatorId');
        const callId = params.get('callId');
        const workspaceId = params.get('workspaceId');

        return {
            token,
            wssUrl,
            fullName,
            language,
            isP2P,
            isSIP,
            soundEnabledParam,
            notificationsEnabledParam,
            joinApprovalPolicy,
            initiatorId,
            callId,
            workspaceId,
        };
    };

    return {
        getStartQueryParams,
    };
};
